export default {
  title: 'Accueil',
  message: {
    meeting: '<b>Bienvenue dans votre espace client !</b><br>Vous trouverez ici toutes les informations concernant votre projet de déménagement.',
    comparator: 'Vos devis sont prêts !',
    comparatorMinarm: 'Choisissez votre déménageur et constituez votre dossier auprès @:base.minarm_organism_du pour organiser votre déménagement facilement avec Nextories !',
    comparatorNoOffer: 'Vos devis sont en cours de préparation, vous recevrez un email dès qu\'ils seront disponibles.',
    contractor: 'Chez Nextories, nous déménageons vos cartons et vos contrats !',
    final: 'Voici les informations concernant l’organisation de votre déménagement.',
  },
  meeting: {
    meetingScheduled: {
      cancelButton: 'Annuler le rendez-vous',
      modifyButton: 'Déplacer',
      title: 'Mon rendez-vous',
      pre: 'Vous avez rendez-vous',
      tel: 'par téléphone',
      homeVisit: 'à votre domicile',
      visio: 'par visioconférence',
      the: 'le',
      end: 'avec {name}, l\'expert en charge de votre dossier',
      meeting: ' {date} à {hours}H{minutes} ',
      explanationText: 'Cette étude technique, gratuite et sans engagement, nous permettra de vous proposer une sélection de 3 à 6 devis fermes et définitifs pour votre déménagement.',
      cancelText: 'En cas d\'indisponibilité, nous vous invitons à déplacer ou annuler votre rendez-vous.',
      cancelTextDomicile: 'En cas d\'indisponibilité, nous vous invitons à annuler votre rendez-vous ou à nous recontacter pour le déplacer.',
      addToCalendar: 'Ajouter à mon calendrier : ',
      googleCalendar: 'Google',
      appleCalendar: 'iCal',
    },
    meetingNotScheduled: {
      title: 'Vous n\'avez pas encore de rendez-vous !',
      text: 'Vous devez planifier un rendez-vous avec un de nos conseillers pour pouvoir déterminer les caractéristiques exactes de votre déménagement, et obtenir des devis fermes.',
      scheduleButton: 'Prendre rendez-vous',
    },
    meetingSchedule: {
      title: 'Prendre rendez-vous',
      subtitle: 'Votre rendez-vous devrait durer environ {time}. Sélectionnez un créneau disponible pour planifier votre rendez-vous.',
      meetingDescription: 'Vous souhaitez réserver un rendez-vous le : ',
      newMeeting: '{date} de {startHours} à {endHours}',
      btn: 'Réserver ce créneau',
    },
    meetingCanceled: {
      title: 'Annuler le rendez-vous',
      cancel: 'Annuler le rendez-vous',
      return: 'Retour',
      reason: 'Je souhaite annuler mon rendez-vous pour la raison suivante :',
      reasons: {
        moverFound: 'J\'ai déjà choisi un déménageur',
        canceled: 'Mon déménagement est annulé',
        reported: 'Mon déménagement est reporté',
        unavailable: 'Je ne suis finalement pas disponible',
        other: 'Autre...',
      },
      comment: {
        text: 'Commentaires :',
        placeholder: 'Un commentaire à ajouter ?',
      },
    },
    emptyDate: 'Aucun créneau disponible, voir les jours suivants',
    loadingText: 'Chargement',
  },
  comparator: {
    title: 'Choix de votre déménageur',
    offersDisplayed: {
      description: {
        offer: 'Ci-dessous la meilleure offre que nous avons sélectionnée pour votre déménagement.<br> Pour visualiser les détails de votre offre, accéder à votre devis et réserver votre déménageur professionnel,&nbsp',
        offers: 'Ci-dessous notre sélection des <b>{nb} meilleures offres</b> pour votre déménagement.<br> Pour visualiser le comparatif détaillé, accéder aux devis et réserver votre déménageur professionnel,&nbsp',
      },
      here: 'veuillez cliquer ici.',
      guarantee: {
        title: 'Validez votre devis avant le {limitDate} pour profiter de la garantie Nextories',
        text: 'Nous vous garantissons les conditions tarifaires obtenues sur chacun des devis présentés pendant {guaranteeDays} jours. Au delà de ce délai, votre déménageur pourra être amené à revoir ses conditions.',
      },
    },
    minarm: {
      step0: 'Votre pré-réservation est en cours de validation auprès de notre partenaire déménageur. Dès que sa disponibilité sera confirmée, nous vous alerterons par email (sous 24h maximum).',
      step1: 'Félicitations, vous avez pré-réservé l\'offre nécessaire pour constituer votre dossier de déménagement. Il ne reste plus qu\'à constituer votre dossier auprès @:base.minarm_organism_du pour finaliser la réservation. Pour cela, ',
      step1Link: 'cliquez ici pour connaître la démarche à suivre.',
      step1LinkPath: 'procedures',
      step2: 'Suite à l\'envoi de votre dossier, la pré-réservation a été validée par @:base.minarm_organism_le !',
      step2Link: 'Cliquez ici pour finaliser la réservation de votre déménageur.',
      step2LinkPath: '/comparator/{offerId}#{signPath}',
      stepReSign: '🔔 Suite à une modification sur votre dossier, nous avons mis à jour votre devis. Afin de valider la bonne prise en compte de ces modifications, merci de bien vouloir signer la nouvelle version de votre devis en cliquant sur le bouton ci-dessous.',
      stepReSignButton: 'Signer le devis',
      stepReSignButtonAction: 'displaySigningModal',
    },
    commissionnaire: {
      step0: '<b>Votre pré-réservation est en cours de validation auprès de notre partenaire déménageur.</b><br>Dès que sa disponibilité sera confirmée, nous transmettrons l\'offre à votre entreprise pour validation de la prise en charge (sous 24 à 48h maximum).',
      step1: '<b>Bonne nouvelle, votre pré-réservation a été confirmée par le déménageur.</b> Il ne reste plus qu\'à attendre la validation de la prise en charge par votre entreprise.',
      step2: 'Suite à l\'analyse de votre dossier, votre déménagement a été validé par votre entreprise !',
      step2Link: 'Cliquez ici pour finaliser la réservation de votre déménageur.',
      step2LinkPath: '/comparator/{offerId}#{signPath}',
      stepReSign: '🔔 Suite à une modification sur votre dossier, nous avons mis à jour votre devis. Afin de valider la bonne prise en compte de ces modifications, merci de bien vouloir signer la nouvelle version de votre devis en cliquant sur le bouton ci-dessous.',
      stepReSignButton: 'Signer le devis',
      stepReSignButtonAction: 'displaySigningModal',
    },
    individual: {
      step0: '<b>Votre pré-réservation est en cours de validation auprès de notre partenaire déménageur.</b><br>Dès que sa disponibilité sera confirmée, nous vous alerterons par email (sous 24 à 48h maximum).',
      step1: '<b>Bonne nouvelle, votre pré-réservation a été confirmée par le déménageur.</b> Il ne vous reste plus qu\'à signer le devis en ligne !',
      step1Link: 'Cliquez ici pour finaliser la réservation de votre déménageur.',
      step1LinkPath: '/comparator/{offerId}#{signPath}',
      step2: '<b>Bonne nouvelle, votre pré-réservation a été confirmée par le déménageur.</b> Il ne vous reste plus qu\'à signer le devis en ligne !',
      step2Link: 'Cliquez ici pour finaliser la réservation de votre déménageur.',
      step2LinkPath: '/comparator/{offerId}#{signPath}',
      stepReSign: '🔔 Suite à une modification sur votre dossier, nous avons mis à jour votre devis. Afin de valider la bonne prise en compte de ces modifications, merci de bien vouloir signer la nouvelle version de votre devis en cliquant sur le bouton ci-dessous.',
      stepReSignButton: 'Signer le devis',
      stepReSignButtonAction: 'displaySigningModal',
    },
    noOffers: 'Nous négocions pour vous les meilleurs tarifs auprès de nos partenaires déménageurs. Dès que vos offres seront disponibles, nous vous en informerons par email et vous les retrouverez ici.',
    displayQuotation: 'Voir mon offre | Voir toutes mes offres',
    noRating: 'Pas encore d\'avis',
  },
  password: {
    message: 'Vous n\'avez pas encore renseigné de mot de passe',
    link: 'renseignez le en cliquant ici !',
    btn: 'Renseigner un mot de passe',
  },
  paymentPending: {
    message: {
      danger: 'Vous avez un paiement à valider.',
      warning: 'Votre paiement est en cours de vérification.',
    },
    link: {
      danger: 'Validez le paiement en cliquant ici !',
      warning: 'Voir le paiement.',
    },
    btn: {
      danger: 'Valider le paiement',
      warning: 'Voir',
    },
  },
  contractor: {
    title: 'Transfert des contrats',
    description1: 'Gagnez du temps ! Nextories vous accompagne également dans le <b>transfert de tous vos contrats : électricité, internet, assurance</b>.',
    description2: 'Le déménagement est le moment idéal pour <b>comparer vos contrats et <b>réduire vos factures</b>.',
    question: 'Souhaitez-vous être contacté afin de bénéficier de ce service rapide et gratuit ?',
    yes: 'Rappelez-moi en priorité',
    no: 'Ignorer',
    more_infos_link: 'Plus d\'infos',
  },
  final: {
    moving: {
      title: 'Mon déménagement',
      loadingDate: 'Chargement',
      deliveryDate: 'Livraison',
      formule: {
        form_luxe: 'Formule complète',
        form_standard: 'Formule standard',
        form_eco: 'Formule économique',
        form_transport: 'Formule transport',
      },
    },
    daterange: {
      from: 'entre le',
      to: 'et le',
      single: 'le',
    },
    mover: {
      mover: 'Mon déménageur',
      contact: 'Contact',
    },
    assurance: {
      title: 'Ma garantie',
    },
    btn: 'Voir les détails',
    yourExpert: 'Votre expert',
  },
  descriptifsCards: {
    myMove: 'Mon déménagement',
    details: 'Détails',
    yourExpert: 'Votre expert en déménagement<br><b>{expert}</b>',
    contactExpert: 'Besoin d\'aide ?<br>Contactez votre expert <b>{expert}</b>',
    aQuestion: 'Besoin d\'aide ?',
    contactUs: 'Contactez-nous !',
    contact: 'Contact',
    myInventory: 'Mon inventaire',
    inventoryText: 'Consultez l’inventaire de vos biens à déménager',
    see: 'Voir',
    guide: 'Guide du déménagement',
    download: 'Télécharger',
    contractTransfert: 'Transfert des contrats',
    simpleLife: 'Simplifiez-vous la vie, on s\'occupe de tout !',
    know: 'En savoir plus',
    noExpert: 'Pas encore d\'expert',
    simpleMove: 'Pour un déménagement en toute tranquillité',
  },
  trustpilot: {
    title: 'Notre priorité : votre satisfaction',
  },
};
